import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
/** Components Import */
import RequireAuth from './RequireAuth';
import Login from '../Scripts/Login/LoginFunction'; // Login
import Terms from '../Scripts/Terms/Terms'; // 약관
//#region 공통
import Home from '../Scripts/Home/HomeFunction'; // Home
import MyPage from '../Scripts/MyPage/MyPageFunction'; // 마이 페이지(설정)
import Profile from '../Scripts/Profile/ProfileFunction'; // 프로필(설정)
import M_Alarm from '../Scripts/Alarm/M_AlarmFunction'; // 알림(설정)
import AlarmList from '../Scripts/AlarmList/AlarmListFunction'; // 알림(목록)
import M_MET_BASICF from '../Scripts/Meeting/M_MET_BASIC/M_MET_BASICF';
import M_MET_BASIC_01F from '../Scripts/Meeting/M_MET_BASIC_01/M_MET_BASIC_01F';
//#endregion
import M_DCM_BASICF from '../Scripts/DocsManagement/M_DCM_BASIC/M_DCM_BASICF'; // 관리자용 문서 관리
import M_EIS_BASICF from '../Scripts/EquipIssuanceStatus/M_EIS_BASIC/M_EIS_BASICF'; // 보호구 수령현황
import M_EIC_BASICF from '../Scripts/EquipIssuance/M_EIC_BASIC/M_EIC_BASICF'; // 보호구 지급
//#endregion
import M_NOT_BASICF from './../Scripts/Notice/M_NOT_BASIC/M_NOT_BASICF'; // 공지/게시 리스트
import M_NOT_BASIC_02F from '../Scripts/Notice/M_NOT_BASIC_02/M_NOT_BASIC_02F'; // 공지 작성
import M_NOT_BASIC_01F from '../Scripts/Notice/M_NOT_BASIC_01/M_NOT_BASIC_01F'; // 공지 상세
import M_NOT_BASIC_03F from '../Scripts/Notice/M_NOT_BASIC_03/M_NOT_BASIC_03F'; // 게시 상세
import M_WOS_Master_BASICF from '../Scripts/WorkStop/Master/M_Master_BASICF';
import M_WOS_BASICF from '../Scripts/WorkStop/M_WOS_BASIC/M_WOS_BASICF';
import M_WOS_BASIC_01F from '../Scripts/WorkStop/M_WOS_BASIC_01/M_WOS_BASIC_01F';
import M_WOS_BASIC_02F from './../Scripts/WorkStop/M_WOS_BASIC_02.js/M_WOS_BASIC_02F';
import M_WOS_BASIC_03F from './../Scripts/WorkStop/M_WOS_BASIC_03/M_WOS_BASIC_03F';
import M_WOE_BASICF from './../Scripts/WorkEnd/M_WOE_BASIC/M_WOE_BASICF';
import M_WOE_BASIC_01F from '../Scripts/WorkEnd/M_WOE_BASIC_01/M_WOE_BASIC_01F';
import M_WOE_BASIC_02F from './../Scripts/WorkEnd/M_WOE_BASIC_02/M_WOE_BASIC_02F';
import M_PPE_BASICF from '../Scripts/PPE/M_PPE_BASIC/M_PPE_BASICF';
import M_AIC_BASICF from '../Scripts/AiCall/M_AIC_BASIC/M_AIC_BASICF';
import M_TCS_BASICF from '../Scripts/TBMCompletionStatus/TCS_BASIC/M_TCS_BASICF'; // TBM 이수현황

// 작업허가서는 동적 라우팅으로 처리 (routeConfig 사용)
import { DynamicRouteWrapper } from './DynamicRouteWrapper';
import Privacy from '../Scripts/Login/Privacy';
import Layout from '../Layout/Layout';
import IdentityMokCallback from '../Scripts/Login/IdentityMokCallback';
import M_PEA_BASICF from '../Scripts/PendingApprovals/M_PEA_BASIC/M_PEA_BASICF';
import M_PEA_EDU_LOG_DETAILF from '../Scripts/PendingApprovals/M_PEA_BASIC/M_PEA_EDU_LOG_DETAILF';
import M_TRA_SIGNF from '../Scripts/TrainingAttendance/M_TRA_SIGN/M_TRA_SIGNF';
import InAppNoti from '../Components/Ui/InAppNoti';
import TbmLinkHandler from '../Scripts/ToolBoxMeeting/GUEST/TbmLinkHandler'; // TBM 입장 링크(앱 링크) 수신
import M_GUIDE_BASICF from './../Scripts/Guide/M_GUIDE_BASIC/M_GUIDE_BASICF';
import M_GUIDE_BASIC_01F from '../Scripts/Guide/M_GUIDE_BASIC_01/M_GUIDE_BASIC_01F';
import M_EXT_SIGN_BASICF from '../Scripts/ExternalSign/M_EXT_SIGN_BASICF';
import M_Equipment_NEWF from '../Scripts/Equipment/NEW/Master/M_Master_NEWF'; // 보호구 관리 (지급 + 수령현황)
import M_EMT_BASIC_01F from '../Scripts/EmergencyTel/M_EMT_BASIC_01/M_EMT_BASIC_01F';
import M_EMT_BASICF from '../Scripts/EmergencyTel/M_EMT_BASIC/M_EMT_BASICF';
//#endregion

// TBM 게스트(일반 카메라 QR 웹 참석) — 로그인 없이 진입, 게스트 화면만 따로 불러옴
const M_TbmGuest_BASICF = React.lazy(
  () => import('../Scripts/ToolBoxMeeting/GUEST/M_TbmGuest_BASICF')
);

export default function Routers() {
  return (
    <BrowserRouter>
      <InAppNoti />
      <TbmLinkHandler />
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <Login />
            </RequireAuth>
          }
        />
        <Route
          path="/privacy"
          element={
            <RequireAuth>
              <Privacy />
            </RequireAuth>
          }
        />
        <Route path="/mok-callback" element={<IdentityMokCallback />} />
        <Route
          element={
            <RequireAuth>
              <Layout />
              {/* <Drawer /> */}
            </RequireAuth>
          }
        >
          {/** 공통 */}
          <Route path="/Home" element={<Home />} />
          <Route path="/M_EmergencyTel" element={<M_EMT_BASICF />} />
          <Route path="/M_EmergencyTel/write" element={<M_EMT_BASIC_01F />} />
          <Route path="/M_Notice" element={<M_NOT_BASICF />} />
          <Route path="/M_Notice/write" element={<M_NOT_BASIC_02F />} />
          <Route path="/M_Notice/write/:id" element={<M_NOT_BASIC_02F />} />
          <Route path="/M_Notice/detail/:id" element={<M_NOT_BASIC_01F />} />
          <Route path="/M_Post/detail/:id" element={<M_NOT_BASIC_03F />} />
          <Route path="/MyPage" element={<MyPage />} />
          <Route path="/Profile" element={<Profile />} />
          <Route path="/M_Alarm" element={<M_Alarm />} />
          <Route path="/M_AlarmList" element={<AlarmList />} />
          {/* 안전신문고: menuInfo proId에 따라 BASIC / DAI 선택 */}
          <Route
            path="/M_WorkInfo"
            element={<DynamicRouteWrapper menuId="M_WorkInfo" path="list" />}
          />
          <Route
            path="/M_WorkInfo/choose"
            element={<DynamicRouteWrapper menuId="M_WorkInfo" path="choose" />}
          />
          <Route
            path="/M_WorkInfo/write/:gubun"
            element={<DynamicRouteWrapper menuId="M_WorkInfo" path="write" />}
          />
          <Route
            path="/M_WorkInfo/action"
            element={<DynamicRouteWrapper menuId="M_WorkInfo" path="action" />}
          />

          {/* 위험성평가하기: menuInfo proId에 따라 BASIC / DAI 선택 */}
          <Route
            path="/M_RNM"
            element={<DynamicRouteWrapper menuId="M_RNM" path="list" />}
          />
          <Route
            path="/M_RNM/choose"
            element={<DynamicRouteWrapper menuId="M_RNM" path="choose" />}
          />
          <Route
            path="/M_RNM/write/:gubun"
            element={<DynamicRouteWrapper menuId="M_RNM" path="write" />}
          />
          <Route
            path="/M_RNM/action"
            element={<DynamicRouteWrapper menuId="M_RNM" path="action" />}
          />

          {/* 작업허가서: menuInfo에 따라 동적으로 컴포넌트 선택 (routeConfig 사용) */}
          <Route
            path="/M_Permit"
            element={<DynamicRouteWrapper menuId="M_Permit" path="list" />}
          />
          <Route
            path="/M_Permit/write"
            element={<DynamicRouteWrapper menuId="M_Permit" path="write" />}
          />
          <Route
            path="/M_Permit/write/:id"
            element={<DynamicRouteWrapper menuId="M_Permit" path="write" />}
          />
          <Route
            path="/M_Permit/detail/:id"
            element={<DynamicRouteWrapper menuId="M_Permit" path="detail" />}
          />
          <Route
            path="/M_Permit/extand/:id"
            element={<DynamicRouteWrapper menuId="M_Permit" path="extand" />}
          />

          {/* 교육 파일 */}
          <Route
            path="/M_File"
            element={<DynamicRouteWrapper menuId="M_File" path="list" />}
          />
          <Route path="/M_PPE" element={<M_PPE_BASICF />} />
          <Route path="/M_AiCall" element={<M_AIC_BASICF />} />

          {/* TBM 교육 설정 */}
          <Route
            path="/M_TBMSetting"
            element={<DynamicRouteWrapper menuId="M_TBMManager" path="setting" />}
          />
          {/* TBM 관리자 */}
          <Route
            path="/M_TBMManager"
            element={<DynamicRouteWrapper menuId="M_TBMManager" path="write" />}
          />
          {/* TBM 근로자 */}
          <Route
            path="/M_TBM"
            element={<DynamicRouteWrapper menuId="M_TBM" path="list" />}
          />
          {/* TBM 이수현황 */}
          <Route path="/M_TBMCompletionStatus" element={<M_TCS_BASICF />} />
          {/* ToolBoxMeeting */}
          {/* <Route path="/M_ToolBoxMeeting" element={<M_Master_BASICF />} /> */}
          {/* 안전보건교육 참석 서명 */}
          <Route path="/M_TRA/sign/:sessionCd" element={<M_TRA_SIGNF />} />
          {/* 나의 결재 대기 */}
          <Route path="/M_PendingApprovals" element={<M_PEA_BASICF />} />
          <Route
            path="/M_PendingApprovals/detail/:id"
            element={<M_PEA_EDU_LOG_DETAILF />}
          />

          {/* 작업중지 */}
          <Route path="/M_WorkStop" element={<M_WOS_Master_BASICF />} />
          <Route path="/M_WorkStop/write" element={<M_WOS_BASIC_01F />} />
          <Route path="/M_WorkStop/detail/:id" element={<M_WOS_BASIC_02F />} />
          <Route path="/M_WorkStop/list" element={<M_WOS_BASICF />} />
          <Route path="/M_WorkStop/:id" element={<M_WOS_BASIC_03F />} />
          {/* 작업종료 */}
          <Route path="/M_WorkEnd" element={<M_WOE_BASICF />} />
          <Route path="/M_WorkEnd/write" element={<M_WOE_BASIC_01F />} />
          <Route path="/M_WorkEnd/detail/:id" element={<M_WOE_BASIC_02F />} />
          {/* 회의록 */}
          <Route path="/M_Meeting" element={<M_MET_BASICF />} />
          <Route path="/M_Meeting/detail/:id" element={<M_MET_BASIC_01F />} />

          {/* 교육자료 */}
          <Route
            path="/M_TrainingPage"
            element={
              <DynamicRouteWrapper menuId="M_TrainingPage" path="list" />
            }
          />
          <Route
            path="/M_TrainingPage/edu/:id"
            element={<DynamicRouteWrapper menuId="M_TrainingPage" path="edu" />}
          />
          <Route
            path="/M_TrainingPage/video/:id"
            element={
              <DynamicRouteWrapper menuId="M_TrainingPage" path="video" />
            }
          />
          <Route
            path="/M_TrainingPage/write"
            element={
              <DynamicRouteWrapper menuId="M_TrainingPage" path="write" />
            }
          />
          <Route
            path="/M_TrainingPage/write/:id"
            element={
              <DynamicRouteWrapper menuId="M_TrainingPage" path="write" />
            }
          />
          {/* 문서 관리 */}
          <Route path="/M_DocsManagement" element={<M_DCM_BASICF />} />
          {/* 보호구 수령현황 */}
          <Route path="/M_EquipIssuanceStatus" element={<M_EIS_BASICF />} />
          {/* 보호구 지급 */}
          <Route path="/M_EquipIssuance" element={<M_EIC_BASICF />} />
          {/* 보호구 관리 (지급 + 수령현황 탭) */}
          <Route path="/M_Equipment" element={<M_Equipment_NEWF />} />
          {/* 가이드 */}
          <Route path="/M_Guide" element={<M_GUIDE_BASICF />} />
          <Route
            path="/M_Guide/manual/:manualKey"
            element={<M_GUIDE_BASIC_01F />}
          />
        </Route>

        <Route
          path="*"
          element={
            <RequireAuth>
              <Login />
            </RequireAuth>
          }
        />
        <Route path="/Terms" element={<Terms />} />
        <Route
          path="/M_ExternalSign/:id/:tel"
          element={<M_EXT_SIGN_BASICF />}
        />
        {/* TBM 진행자 QR을 일반 카메라로 스캔했을 때 (비회원 웹 참석) */}
        <Route
          path="/tbm/join/:token"
          element={
            <React.Suspense fallback={null}>
              <M_TbmGuest_BASICF />
            </React.Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
